import { Route, Routes } from "react-router-dom";
import TaskGradingEditInvisiblePage from './TaskGradingEditInvisiblePage';
import TaskGradingEditVisiblePage from './TaskGradingEditVisiblePage';
import EmployeeDetailPage from './EmployeeDetailPage';

export default function EmployeeDetailPageRouter() {
  return (
    <Routes>
      <Route path='' element={<EmployeeDetailPage />} />
      <Route path='open' element={<TaskGradingEditVisiblePage />} />
      <Route path='close' element={<TaskGradingEditInvisiblePage />} />
    </Routes>
  );
}
